import _ from 'lodash';
import { getField, updateField } from 'vuex-map-fields';

const state = {
    contadores: {
        reportes: 0,
        inspecciones: 0,
        disponibles: 0,
        vr_inventario: 0
    },
    graficos: {
        reportes_mes: [],
        inspecciones_mes: [],
        disponibles_mes: [],
        reportes_disponibles_mes: [],
        reportes_asesor: [],
        leads_asesor: []
    },
    gestion: {
        asesor_selected: 'all',
        sin_gestion: 0,
        tareas_pendientes: 0,
        tareas_hoy: 0,  
    },
    consignaciones: {
        cotizado: 0,
        avaluo: 0,
        cierre: 0,
        inspeccion_legal: 0,
        inspeccion_mecanica: 0,
        mercadeo: 0,
        ficha_inventario: 0,
        retirado: 0,
        vendido: 0
    },
    inspecciones: {
        exterior: 0,
        encuesta: 0
    },
    facturacion: {
        cant_pagados: 0,
        cuentas_por_cobrar: 0,
        obsequio: 0
    },
    tareas: []
};
const mutations = {
    updateField,
    updateContadores: (state, payload) => {
        state.contadores = {...state.contadores, ...payload};
    },
    updateGestion: (state, payload) => {
        state.gestion = {...state.gestion, ...payload.gestion};
        state.consignaciones = {...state.consignaciones, ...payload.estados};
        state.inspecciones = {...state.inspecciones, ...payload.InspeccionesPendientes, ...payload.InspeccionesCompletas};
        state.facturacion = {...state.facturacion, ...payload.facturacion};
        state.tareas = payload.tareas;
    }
};
const getters = {
    getField,
};
export default {
    namespaced: true,
    state,
    mutations,
    getters
}
